export default __webpack_public_path__ + "static/media/POS_Mobile.d42570a7.svg";